import { __generator } from "tslib";
import { put, takeLatest, call, delay, all, takeEvery, select, race, take, } from 'redux-saga/effects';
import { request } from '../../xhr';
import { pushModal, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { actions as notificationActions, NotificationType, } from '../../Notifications';
import ErrorIcon from '../../Icons/Error';
import { fetchLiveNotificationsSettings, fetchLiveNotificationsSettingsSuccess, fetchLiveNotificationsSettingsFailure, saveLiveNotificationsSettings, saveLiveNotificationsSettingsSuccess, saveLiveNotificationsSettingsFailure, deletePortfolio, deletePortfolioSuccess, } from './actions';
import { messageReceived } from '../../redux/messages/action';
import { getIsMobile } from '../../publicSession';
import { ModalType } from '../../Modals/redux/types';
var DEBOUNCE_DELAY = 200;
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        switch (options.url) {
            case '/user/settings/hub/config':
                return {
                    enabled: false,
                    types: {
                        comments: true,
                        replies: true,
                        mentions: true,
                        activity: false,
                        correspondence: false,
                    },
                };
            case '/user/settings/hub/save':
            default:
                return { success: true };
        }
    }
}
function fetchLiveNotificationsSettingsHandler() {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, delay(DEBOUNCE_DELAY)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: '/user/settings/hub/config',
                    }, fakeResponse)];
            case 2:
                result = _a.sent();
                if (!(result && !result['error'])) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchLiveNotificationsSettingsSuccess(result))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(fetchLiveNotificationsSettingsFailure())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function saveLiveNotificationsSettingsHandler(_a) {
    var enabled, types, params, result;
    var settings = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, delay(DEBOUNCE_DELAY)];
            case 1:
                _b.sent();
                enabled = settings.enabled, types = settings.types;
                params = Object.keys(types).reduce(function (acc, name) {
                    if (types[name]) {
                        acc["type_" + name] = true;
                    }
                    return acc;
                }, { enabled: enabled });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/user/settings/hub/save",
                        data: params,
                    }, fakeResponse)];
            case 2:
                result = _b.sent();
                if (!(result && !result['error'])) return [3 /*break*/, 4];
                return [4 /*yield*/, put(saveLiveNotificationsSettingsSuccess(settings))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(saveLiveNotificationsSettingsFailure())];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function handleMessage(_a) {
    var _b, notificationsIframe, isMobile;
    var message = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = message.type;
                switch (_b) {
                    case 'NotificationsDropdown': return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1:
                notificationsIframe = document.getElementById('eclipse-notifications-iframe');
                return [4 /*yield*/, select(getIsMobile)];
            case 2:
                isMobile = _c.sent();
                // only resize the notifications iframe on desktop
                if (notificationsIframe && message.height && !isMobile) {
                    notificationsIframe.style.height = message.height;
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}
function handleDeletePortfolio() {
    var no, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(pushModal(ModalType.WIX_PORTFOLIO_DELETE, {}))];
            case 1:
                _a.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 2:
                no = (_a.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/wix_portfolio/delete',
                    }, function () { return ({ success: true }); })];
            case 3:
                result = _a.sent();
                if (!result.success) return [3 /*break*/, 6];
                // this is picked up in publicSession and makes hasWixPortfolio false
                return [4 /*yield*/, put(deletePortfolioSuccess())];
            case 4:
                // this is picked up in publicSession and makes hasWixPortfolio false
                _a.sent();
                return [4 /*yield*/, put(pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInPopup: false }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(notificationActions.addNotification(NotificationType.Generic, {
                    messageLocaleKey: 'common.somethingWentWrong',
                    cardProps: { iconComponent: ErrorIcon },
                }))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(fetchLiveNotificationsSettings, fetchLiveNotificationsSettingsHandler),
                    takeLatest(saveLiveNotificationsSettings, saveLiveNotificationsSettingsHandler),
                    takeEvery(messageReceived, handleMessage),
                    takeEvery(deletePortfolio, handleDeletePortfolio),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map